import { useQuery } from "@tanstack/react-query";
import { getLowEngagementTeens } from "@/lib/api/mentors";

export const useLowEngagementTeens = (enabled = true) => {
  return useQuery({
    queryKey: ["low-engagement-teens"],
    queryFn: getLowEngagementTeens,
    enabled,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes - data doesn't change frequently
    retry: 2,
  });
};
